import { gql } from '@apollo/client/core';
import { TICKET_FRAGMENT } from '@/graphql/Fragments/tickets';

export const GET_TICKET_CATEGORIES = gql`
    query GetTicketCategories {
        ticketCategories {
            id
            name
            priority
            auto_response
            is_active
        }
    }
`;

export const GET_TICKETS = gql`
    query GetTickets($status: TicketStatus, $priority: TicketPriority, $category_id: ID, $page: Int) {
        tickets(status: $status, priority: $priority, ticket_category_id: $category_id, page: $page) {
            data {
                ...TicketFragment
            }
            paginatorInfo {
                total
                currentPage
                hasMorePages
                lastPage
            }
        }
    }
    ${TICKET_FRAGMENT}
`;

export const GET_TICKET = gql`
    query GetTicket($id: ID!) {
        ticket(id: $id) {
            ...TicketFragment
            description
            attachments {
                id
                file { url original_name mime_type }
            }
            messages {
                id
                message
                created_at
                scheduled_at
                status
                sender {
                     ... on User { id name }
                     ... on Student { id surname first_name }
                }
                attachments {
                    id
                    file { url original_name mime_type }
                }
            }
        }
    }
    ${TICKET_FRAGMENT}
`;
